export default __webpack_public_path__ + "static/line-with-gaps-ffbefe93c4e6b2ec171a20a4a23a3788.png";